// import { NextParsedUrlQuery } from 'next/dist/server/request-meta';
// import { ReadonlyURLSearchParams } from "next/navigation";
import { omitNullKeys } from "@habity/utils";
import { NestedSearch, TODO } from "@habity/types";

// export const parseFiltersFromQuery = (query: NextParsedUrlQuery) => {
//   const {
//     tags,
//     types,
//     statuses,
//     price,
//     rooms,
//     plotSize,
//     size,
//     monthlyFee,
//     city,
//     zip,
//     country,
//   } = query || {};
//   if (!query) return null;
//   // Make a string to start analyzing it
//   const filters = {
//     tags: getArrayValue(tags),
//     categories: getArrayValue(types),
//     statuses: getArrayValue(statuses),
//     city: getValue(city),
//     zip: getValue(zip),
//     price: getRangeValue(price),
//     rooms: getRangeValue(rooms),
//     plotSize: getRangeValue(plotSize),
//     monthlyFee: getRangeValue(monthlyFee),
//     livingSpace: getRangeValue(size),
//     country: getValue(country),
//   } as Partial<NestedSearch>;
//   return filters;
// };

// const getArrayValue = (value: string | string[] | undefined) => {
//   if (!value) return null;
//   return typeof value === 'string' ? value.split(',') : value;
// };

// const getValue = (value: string | string[] | undefined) => {
//   if (!value) return undefined;
//   return value as string;
// };

// const getRangeValue = (
//   value: string | string[] | undefined
// ): RangeType | undefined => {
//   if (!value) return undefined;
//   const values = typeof value === 'string' ? value.split(',') : value;
//   return {
//     min: Number(values[0]),
//     max: values.length > 1 ? Number(values[1]) : null,
//   };
// };

export const getFilterArrayValues = (
  values: TODO[] | TODO,
  prevValues?: TODO[] | null
) => {
  let newValues = [...(prevValues || [])];
  if (Array.isArray(values)) {
    values.forEach((value) => {
      if (newValues.includes(value)) {
        newValues = newValues.filter((v) => v !== value);
      } else {
        newValues.push(value);
      }
    });
  } else {
    if (newValues.includes(values)) {
      newValues = newValues.filter((v) => v !== values);
    } else {
      newValues.push(values);
    }
  }
  return newValues.length > 0 ? newValues : undefined;
};

// Convert string/array 'true'/'false' to boolean, handles URL query param formats
export const getBooleanValue = (value: string | string[] | boolean | undefined): boolean | undefined => {
  if (value === undefined || value === null) return undefined;
  if (typeof value === 'boolean') return value;
  const strValue = Array.isArray(value) ? value[0] : value;
  if (strValue === 'true') return true;
  if (strValue === 'false') return false;
  return undefined;
};

export const getArrayValue = (value: string | string[] | undefined) => {
  if (!value || (value && value.length === 0)) return null;

  if (value instanceof Array) {
    const hasNonStringItems = value.some((v) => typeof v !== "string");

    if (!hasNonStringItems) {
      const hasCommas = value.some((v) => v && v.includes(","));

      if (hasCommas) {
        return value.flatMap((v) => v.split(",").map((item) => item.trim()));
      }
    }
    return value;
  }

  if (typeof value === "string" && value.includes(",")) {
    return value.split(",").map((item) => item.trim());
  }

  return [value];
};

export const getFiltersFromQuery = (searchParams: TODO | null) => {
  const latitude = searchParams?.get("latitude");
  const longitude = searchParams?.get("longitude");
  const streetWithCity = searchParams?.get("streetWithCity");
  const zips = searchParams?.getAll("zips");
  const city = searchParams?.get("city");
  const streets = searchParams?.getAll("streets");
  const build_year_min = searchParams?.get("build_year_min");
  const build_year_max = searchParams?.get("build_year_max");
  const monthly_fee_min = searchParams?.get("monthly_fee_min");
  const monthly_fee_max = searchParams?.get("monthly_fee_max");
  const plot_size_min = searchParams?.get("plot_size_min");
  const plot_size_max = searchParams?.get("plot_size_max");
  const price_min = searchParams?.get("price_min");
  const price_max = searchParams?.get("price_max");
  const rooms_min = searchParams?.get("rooms_min");
  const rooms_max = searchParams?.get("rooms_max");
  const bedrooms_min = searchParams?.get("bedrooms_min");
  const bedrooms_max = searchParams?.get("bedrooms_max");
  const living_space_min = searchParams?.get("living_space_min");
  const living_space_max = searchParams?.get("living_space_max");
  const is_rental_unit = searchParams?.get("is_rental_unit");
  const is_claimed = searchParams?.get("is_claimed");
  const label = searchParams?.get("label");
  const categories = searchParams?.getAll("categories");
  const places = searchParams?.getAll("places");
  const statuses = searchParams?.getAll("statuses");
  const features = searchParams?.getAll("features");
  const nearby = searchParams?.getAll("nearby");
  const municipalityIds = searchParams?.getAll("municipalityIds");
  const areaIds = searchParams?.getAll("areaIds");
  const brokerIds = searchParams?.getAll("brokerIds");
  const entityIds = searchParams?.getAll("entityIds");
  const ignore_home_ids = searchParams?.getAll("ignore_home_ids");
  const office_ids = searchParams?.getAll("officeIds");
  const streetIds = searchParams?.getAll("streetIds");
  const excludeAssistants = searchParams?.get("excludeAssistants");
  const requireContainingArea = searchParams?.get("requireContainingArea");

  const filters = {
    latitude,
    longitude,
    streetWithCity: null, // Set null to omit
    streets: streetWithCity ? streetWithCity[0] : streets ? streets : null,
    zips: zips,
    city: streetWithCity ? streetWithCity[1] : city || null,
    build_year_min: build_year_min ? Number(build_year_min) : null,
    build_year_max: build_year_max ? Number(build_year_max) : null,
    monthly_fee_min: monthly_fee_min ? Number(monthly_fee_min) : null,
    monthly_fee_max: monthly_fee_max ? Number(monthly_fee_max) : null,
    plot_size_min: plot_size_min ? Number(plot_size_min) : null,
    plot_size_max: plot_size_max ? Number(plot_size_max) : null,
    price_min: price_min ? Number(price_min) : null,
    price_max: price_max ? Number(price_max) : null,
    rooms_min: rooms_min ? Number(rooms_min) : null,
    rooms_max: rooms_max ? Number(rooms_max) : null,
    bedrooms_min: bedrooms_min ? Number(bedrooms_min) : null,
    bedrooms_max: bedrooms_max ? Number(bedrooms_max) : null,
    living_space_min: living_space_min ? Number(living_space_min) : null,
    living_space_max: living_space_max ? Number(living_space_max) : null,
    is_rental_unit,
    is_claimed,
    label,
    categories: categories && categories.length > 0 ? categories : null,
    places: places && places.length > 0 ? places : null,
    statuses: statuses && statuses.length > 0 ? statuses : null,
    features: features && features.length > 0 ? features : null,
    nearby: nearby && nearby.length > 0 ? nearby : null,
    municipalityIds:
      municipalityIds && municipalityIds.length > 0 ? municipalityIds : null,
    areaIds: areaIds && areaIds.length > 0 ? areaIds : null,
    brokerIds: brokerIds && brokerIds.length > 0 ? brokerIds : null,
    entityIds: entityIds && entityIds.length > 0 ? entityIds : null,
    ignore_home_ids:
      ignore_home_ids && ignore_home_ids.length > 0 ? ignore_home_ids : null,
    office_ids: office_ids && office_ids.length > 0 ? office_ids : null,
    streetIds: streetIds && streetIds.length > 0 ? streetIds : null,
    excludeAssistants: excludeAssistants ? Boolean(excludeAssistants) : null,
    requireContainingArea: requireContainingArea
      ? Boolean(requireContainingArea)
      : null,
  };

  return omitNullKeys(filters) as Partial<NestedSearch>;
};

// coordinates?: TODO; // Polygon coordinates in JSON format
// longitude?: RangeType;

export const getFiltersFromServerSearchParams = (searchParams: TODO) => {
  const {
    latitude,
    longitude,
    streetWithCity,
    zips,
    city,
    streets,
    build_year_min,
    build_year_max,
    monthly_fee_min,
    monthly_fee_max,
    plot_size_min,
    plot_size_max,
    price_min,
    price_max,
    rooms_min,
    rooms_max,
    bedrooms_min,
    bedrooms_max,
    living_space_min,
    living_space_max,
    is_rental_unit,
    is_claimed,
    categories,
    places,
    statuses,
    features,
    nearby,
    label,
    signedInUserId,
    areaIds,
    municipalityIds,
    brokerIds,
    entityIds,
    ignore_home_ids,
    includeFirstImage,
    officeIds,
    streetIds,
    interests,
    excludeAssistants,
    requireContainingArea,
  } = searchParams || {};

  const filters = {
    latitude,
    longitude,
    streetWithCity: null, // Set null to omit
    streets: streetWithCity
      ? streetWithCity[0]
      : streets
        ? getArrayValue(streets)
        : null,
    zips: getArrayValue(zips),
    city: streetWithCity ? streetWithCity[1] : city || null,
    build_year_min: build_year_min ? Number(build_year_min) : null,
    build_year_max: build_year_max ? Number(build_year_max) : null,
    monthly_fee_min: monthly_fee_min ? Number(monthly_fee_min) : null,
    monthly_fee_max: monthly_fee_max ? Number(monthly_fee_max) : null,
    plot_size_min: plot_size_min ? Number(plot_size_min) : null,
    plot_size_max: plot_size_max ? Number(plot_size_max) : null,
    price_min: price_min ? Number(price_min) : null,
    price_max: price_max ? Number(price_max) : null,
    rooms_min: rooms_min ? Number(rooms_min) : null,
    rooms_max: rooms_max ? Number(rooms_max) : null,
    bedrooms_min: bedrooms_min ? Number(bedrooms_min) : null,
    bedrooms_max: bedrooms_max ? Number(bedrooms_max) : null,
    living_space_min: living_space_min ? Number(living_space_min) : null,
    living_space_max: living_space_max ? Number(living_space_max) : null,
    is_rental_unit: getBooleanValue(is_rental_unit),
    is_claimed: getBooleanValue(is_claimed),
    includeFirstImage: getBooleanValue(includeFirstImage),
    categories: getArrayValue(categories),
    places: getArrayValue(places),
    statuses: getArrayValue(statuses),
    features: getArrayValue(features),
    nearby: getArrayValue(nearby),
    label,
    signedInUserId,
    areaIds: getArrayValue(areaIds)?.map(Number),
    municipalityIds: getArrayValue(municipalityIds)?.map(Number),
    brokerIds: getArrayValue(brokerIds)?.map(Number),
    entityIds: getArrayValue(entityIds)?.map(Number),
    ignore_home_ids: getArrayValue(ignore_home_ids)?.map(Number),
    officeIds: getArrayValue(officeIds)?.map(Number),
    streetIds: getArrayValue(streetIds)?.map(Number),
    interests: getArrayValue(interests),
    excludeAssistants: getBooleanValue(excludeAssistants),
    requireContainingArea: getBooleanValue(requireContainingArea),
  };

  return omitNullKeys(filters) as Partial<NestedSearch>;
};
